module.exports = __webpack_public_path__ + "static/media/meteor.ac3c0b2c.svg";